import script from "./AgreedValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgreedValue.vue?vue&type=script&setup=true&lang=ts"

import "./AgreedValue.vue?vue&type=style&index=0&id=42028a10&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42028a10"]])

export default __exports__